import { render, staticRenderFns } from "./JobCertificationsCard.vue?vue&type=template&id=3eaac154&scoped=true&"
import script from "./JobCertificationsCard.vue?vue&type=script&lang=js&"
export * from "./JobCertificationsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaac154",
  null
  
)

export default component.exports